import { render, staticRenderFns } from "./BuyPlanModal.vue?vue&type=template&id=42460fcf&"
import script from "./BuyPlanModal.vue?vue&type=script&lang=js&"
export * from "./BuyPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports